import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AnnotatorConfig } from '../../annotations/shared/annotator-config';
import { RlFile } from '../../rl-common/file/shared/rl-file';
import { EntityType } from '../../rl-common/shared/shared/entity-type.enum';

@Injectable({
  providedIn: 'root'
})
export class ViewerService {

  constructor(private http : HttpClient) { }

  get = (entityType : EntityType,entityId : string , contentType : string) : Observable<RlFile> => this.http.get<RlFile>(`../rl/avail/${entityType}/${entityId}/${contentType}`);
  getAnnotationsConfig(): AnnotatorConfig {
    let annsConf : AnnotatorConfig = new AnnotatorConfig();
    annsConf.commentsConfig.visibility = "public";
    annsConf.displayPrivatePublicTabs = true;
    return annsConf;
  }
//  get1 = (entityType : EntityType,entityId : string , contentType : string) : Observable<RlFile> => this.http.get<RlFile>(`../rl/avail/${entityType}/${entityId}/${contentType}?entityType=${entityType}&id=${entityId}&contentType=${contentType}`);
}
